export const AdminSystemController = {
    healthIndex(): void {},
    actionsIndex(): void {},
    runAction(): void {},
};
